import React from 'react';
import Box from '@mui/material/Box';
import Helper from '../../utility/helper';
import { useThemeState } from '../../hookState/ThemeState';
import EventCard from '../../components/EventCard/EventCard';


const EventDetailsComponent = (props) => {
    const eventInfo = Helper.getStorage('eventInfo');
    const upcomingEvents = Helper.getStorage('upcomingEvents');

    const themeState = useThemeState();

    function createMarkup() {
        return {
            __html: props.data
        };
    };
    // console.log("upcomingEvents", upcomingEvents);
    return (
        <>


            <Box sx={{ pb: 1, width: '100%',overflow:'auto' }}>
                <div style={{ marginLeft: '1rem' }} dangerouslySetInnerHTML={createMarkup()} />
                {/* <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        // justifyContent: 'evenly',
                    }}>
                    {upcomingEvents && upcomingEvents.length > 0 && upcomingEvents.map((eventList, index) => {
                        return (
                            <EventCard
                                key={`upcoming_${index}`}
                                eventList={eventList}
                                loading={false}
                            />
                        );
                    })}
                </Box> */}
            </Box>
        </>
    );
};

export default EventDetailsComponent;
